
<div class="row">
    <div class="col-md-12 col-lg-9">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">User details</h4>
                <form autocomplete="off" #createUserForm="ngForm">
                    <div class="form-group">
                        <label for="firstName">First Name</label>
                        <input type="text" class="form-control" #firstName="ngModel" [(ngModel)]="createUser.firstName" required
                            name="firstName">
                        <div *ngIf="!firstName.valid && firstName.touched" class="alert alert-danger">
                            Field is required
                        </div>
                    </div>
                
                    <div class="form-group">
                        <label for="lastName">Last Name</label>
                        <input type="text" class="form-control" #lastName="ngModel" [(ngModel)]="createUser.lastName" required
                            name="lastName">
                        <div *ngIf="!lastName.valid && lastName.touched" class="alert alert-danger">
                            Field is required
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="email">Email</label>
                        <input type="text" class="form-control" #email="ngModel" [(ngModel)]="createUser.email" required
                            name="email">
                        <div *ngIf="!email.valid && email.touched" class="alert alert-danger">
                            Field is required
                        </div>
                    </div>                    
                
                    <div class="form-group">
                        <label for="password">Password</label>
                        <input type="password" class="form-control" #password="ngModel" [(ngModel)]="createUser.password" required
                            name="password">
                        <div *ngIf="!password.valid && password.touched" class="alert alert-danger">
                            Field is required
                        </div>
                    </div>     

                    <div class="form-group">
                        <label for="confirmPassword">Confirm Password</label>
                        <input type="password" class="form-control" #confirmPassword="ngModel" [(ngModel)]="createUser.confirmPassword" required
                            name="confirmPassword">
                        <div *ngIf="!confirmPassword.valid && confirmPassword.touched" class="alert alert-danger">
                            Field is required
                        </div>
                    </div>     


                    <button class="btn btn-primary btn-lg" [disabled]="!createUserForm.valid" (click)="create()">Create</button>
                </form>       
            </div>
        </div>
    </div>
</div>
